// src/theme/tokens/motion.js
// Faz 1 · Hareket (motion) token sistemi.
// Mevcut --motion-duration-fast/base/slow/slower CSS variable'lari korunur ve genisletilir.
// Bu dosya hem CSS variable tanimlarini hem de JS tarafinda kullanim icin
// (Framer Motion vb.) export'lari saglar.
// Faz 2'de tum component override'lari bu tokenlari kullanir.

// CSS Variables · theme/styles.js icinden :root altina enjekte edilecek.
const motionCssVars = {
  // ===== EASING (cubic-bezier curve'ler) =====
  '--motion-ease-apple':       'cubic-bezier(0.16, 1, 0.3, 1)',          // Apple HIG default
  '--motion-ease-apple-in':    'cubic-bezier(0.32, 0, 0.67, 0)',
  '--motion-ease-standard':    'cubic-bezier(0.4, 0, 0.2, 1)',           // Material standard
  '--motion-ease-emphasized':  'cubic-bezier(0.2, 0, 0, 1)',             // Material 3 emphasized
  '--motion-ease-decelerate':  'cubic-bezier(0, 0, 0.2, 1)',             // Element entrance
  '--motion-ease-accelerate':  'cubic-bezier(0.4, 0, 1, 1)',             // Element exit
  '--motion-ease-bounce':      'cubic-bezier(0.34, 1.56, 0.64, 1)',      // Playful spring

  // ===== DURATION =====
  '--motion-duration-instant':  '80ms',    // Anlik geri bildirim (button press)
  '--motion-duration-fast':     '160ms',   // Kucuk transitions (hover, color)
  '--motion-duration-base':     '240ms',   // Default (mevcut)
  '--motion-duration-slow':     '360ms',   // Pano/modal entrance
  '--motion-duration-slower':   '520ms',   // Buyuk yuzey gecisleri
  '--motion-duration-slowest':  '720ms',   // Hero animasyonlari

  // ===== SPRING (Framer Motion icin) =====
  '--motion-spring-stiff':    '380',
  '--motion-spring-default':  '260',
  '--motion-spring-soft':     '170',
  '--motion-damping-stiff':   '30',
  '--motion-damping-default': '24',
  '--motion-damping-soft':    '18',

  // ===== STAGGER =====
  '--motion-stagger-tight':   '40ms',
  '--motion-stagger-default': '70ms',
  '--motion-stagger-loose':   '120ms',
};

// Faz 1 ekleme · UI etkilesimi icin yuksek-seviye preset'ler.
// Mevcut motion.duration / motion.ease referanslari uzerinden tanimlanir;
// component'lerde "transition: var(...)" yerine motionPresets.buttonHover gibi
// anlamsal anahtarlar tek noktadan ayarlanir.
const motionPresets = {
  buttonHover:  { duration: '160ms', easing: 'var(--motion-ease-apple)' },
  buttonActive: { duration: '80ms',  easing: 'var(--motion-ease-apple)' },
  modalEnter:   { duration: '320ms', easing: 'var(--motion-ease-decelerate)' },
  modalExit:    { duration: '180ms', easing: 'var(--motion-ease-accelerate)' },
  dismissFade:  { duration: '160ms', easing: 'var(--motion-ease-accelerate)' },
  bannerSlide:  { duration: '240ms', easing: 'var(--motion-ease-apple)' },
  contentSwap:  { duration: '200ms', easing: 'var(--motion-ease-standard)' },
};

// JS export'u · Framer Motion / styled component'lerden import edilebilir.
//
// NOT (kritik): Framer Motion v10/v11 `ease` prop'unda 'cubic-bezier(...)'
// STRING formatini KABUL ETMEZ · sadece named easing ('easeIn', 'easeOut'…)
// veya 4 elemanli array tuple ([x1, y1, x2, y2]) destekler. Geçmişte string
// olarak tanimliydilar ve Layout.jsx gibi Framer Motion'a iletildiklerinde
// 'Invalid easing type' hatasiyla sayfalari kirilmasina yol açiyordu.
// CSS variable degerleri yukaridaki motionCssVars icinde string olarak korunur
// (CSS transition'larda gerekli format); JS ise array tuple kullanir.
const motion = {
  ease: {
    apple:       [0.16, 1, 0.3, 1],
    appleIn:     [0.32, 0, 0.67, 0],
    standard:    [0.4, 0, 0.2, 1],
    emphasized:  [0.2, 0, 0, 1],
    decelerate:  [0, 0, 0.2, 1],
    accelerate:  [0.4, 0, 1, 1],
    bounce:      [0.34, 1.56, 0.64, 1],
  },
  duration: {
    instant:  0.08,
    fast:     0.16,
    base:     0.24,
    slow:     0.36,
    slower:   0.52,
    slowest:  0.72,
  },
  spring: {
    stiff:    { type: 'spring', stiffness: 380, damping: 30 },
    default:  { type: 'spring', stiffness: 260, damping: 24 },
    soft:     { type: 'spring', stiffness: 170, damping: 18 },
    bouncy:   { type: 'spring', stiffness: 220, damping: 14 },
  },
  stagger: {
    tight:    0.04,
    default:  0.07,
    loose:    0.12,
  },
  // Hazir transition siralari (component'lerde direkt kullanim)
  transition: {
    fast:    'all var(--motion-duration-fast) var(--motion-ease-apple)',
    base:    'all var(--motion-duration-base) var(--motion-ease-apple)',
    slow:    'all var(--motion-duration-slow) var(--motion-ease-apple)',
    color:   'color var(--motion-duration-fast) var(--motion-ease-apple), background-color var(--motion-duration-fast) var(--motion-ease-apple)',
    transform: 'transform var(--motion-duration-base) var(--motion-ease-apple)',
    shadow:    'box-shadow var(--motion-duration-base) var(--motion-ease-apple)',
    opacity:   'opacity var(--motion-duration-fast) var(--motion-ease-apple)',
  },
};

export default motion;
export { motionCssVars, motionPresets };
